export const LOAD_FRANCHISEE_DETAIL =
  'app/FranchiseDashboard/LOAD_FRANCHISEE_DETAIL';
export const SET_FRANCHISEE_DETAIL =
  'app/FranchiseDashboard/SET_FRANCHISEE_DETAIL';
export const SET_FRANCHISEE_DATA = 'app/FranchiseDashboard/SET_FRANCHISEE_DATA';
export const SAVE_FRANCHISEE_DATA =
  'app/FranchiseDashboard/SAVE_FRANCHISEE_DATA';
export const GET_FRANCHISEE_ID_DETAILS =
  'app/FranchiseDashboard/GET_FRANCHISEE_ID_DETAILS';
